<!-- <ion-content> -->
    <!-- <ion-navbar>
        <div class="header">
            <div class="btn-back-menu" (click)="onBackMenu()">
                <ion-icon class="no-padding" name="arrow-back"></ion-icon>
                <button ion-button clear color="light" no-padding>
                <strong style="color:black !important" class="margin-sides">{{ 'GLOBAL_BACK' | translate }}</strong>
                </button>
            </div>
            <ion-title>{{ 'SETTINGS' | translate }}</ion-title>
        </div> 
    </ion-navbar> -->
           
     
    <ion-row class="select-container">
        <ion-label>Modus</ion-label>
            <ion-select>
                <ion-option>{{ 'GLOBAL_LEAGUE' | translate }}</ion-option>
                <ion-option>{{ 'GLOBAL_TOURNAMENT' | translate }}</ion-option>
            </ion-select>
    </ion-row>
    <ion-row class="settings">
        <ion-col col-6 class="setting-item">
            <p>Anzahl der Begegnungen</p>
        </ion-col>
        <ion-col col-3 class="calculation" width-25>
            <button class="add-btn" clear (click)="counters[0].value = counters[0].value - 1"><ion-icon name="remove-circle" ></ion-icon></button>
            <span>{{counters[0].value}}</span>
            <button class="add-btn" clear (click)="counters[0].value = counters[0].value + 1"><ion-icon name="add-circle" ></ion-icon></button>
        </ion-col>
    </ion-row>
    <ion-row class="settings">
        <ion-col col-6 class="setting-item">
            <p>Punkte fur den Sieg</p>
        </ion-col>
        <ion-col col-3 class="calculation" width-25>
            <button class="add-btn" clear (click)="counters[1].value = counters[1].value - 1"><ion-icon name="remove-circle" ></ion-icon></button>
            <span>{{counters[1].value}}</span>
            <button class="add-btn" clear (click)="counters[1].value = counters[1].value + 1"><ion-icon name="add-circle" ></ion-icon></button>
        </ion-col>
    </ion-row>
    <ion-row class="settings">
        <ion-col col-6 class="setting-item">
            <p>Punkte fur Unentschieden</p>
        </ion-col>
        <ion-col col-3 class="calculation" width-25>
            <button class="add-btn" clear (click)="counters[2].value = counters[2].value - 1"><ion-icon name="remove-circle" ></ion-icon></button>
            <span>{{counters[2].value}}</span>
            <button class="add-btn" clear (click)="counters[2].value = counters[2].value + 1"><ion-icon name="add-circle" ></ion-icon></button>
        </ion-col>
    </ion-row>
    <ion-row class="settings">
        <ion-col col-6 class="setting-item">
            <p>Punkte fur den Verlust</p>
        </ion-col>
        <ion-col col-3 class="calculation" width-25>
            <button class="add-btn" clear (click)="counters[3].value = counters[3].value - 1"><ion-icon name="remove-circle" ></ion-icon></button>
            <span>{{counters[3].value}}</span>
            <button class="add-btn" clear (click)="counters[3].value = counters[3].value + 1"><ion-icon name="add-circle" ></ion-icon></button>
        </ion-col>
    </ion-row>
<!-- </ion-content> -->